import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import transcriptFetched, {
	type TranscriptFetchedAction,
	type TranscriptPayload,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptFetched';
import transcriptFetchFailed, {
	type TranscriptFetchFailedAction,
} from '@Application/Beneficiaries/Transcripts/Actions/transcriptFetchFailed';
import type FetchTranscript from '@Application/Beneficiaries/Transcripts/Queries/FetchTranscript';
import { get } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = TranscriptFetchedAction | TranscriptFetchFailedAction;

export default (query: FetchTranscript) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await get<TranscriptPayload>(
				`${buildSubjectApiPath(query.facilityId, query.subject)}/interviews/${query.interviewId}/transcript`,
			);

			const action = transcriptFetched(
				payload,
				query.facilityId,
				query.subject.subjectId,
				query.interviewId,
			);
			dispatch(action);
			return action;
		} catch (error) {
			const action = transcriptFetchFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
